import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './qrPayment.module.css'
import '../../components/text/Text.css'
import Text from '../../components/text/Text'
import arrowBack from '../../assets/icons/icons-arrow-back.svg'
import routes from '../../router/routes'
import { useLoadingContext } from '../../context/spinnerContext'
import VerificationInput from 'react-verification-input'
import { processPaymentOrderV2 } from '../../services/payment'
import ModalComponent from '../../components/modal/ModalComponent'
import ErrorModal from '../../components/modal/modalVariants/ErrorModal'
import { VARIANTS, VariantsType } from '../../components/modal/ModalComponent'
import { clevertapEvents, labels } from '../../labels'
import AlertModal from '../../components/modal/modalVariants/AlertModal'
import { track } from '../../ClevertapWrapper'
import { format } from 'date-fns'
import { getLocal, getLocalId } from '../../Utils/Profile'

export default function QrPayment() {
    const navigation = useNavigate()
    const state = useLocation()
    const loadingContext = useLoadingContext()

    const [qrCode, setQrCode] = useState<string>('')
    const [modalContentType, setModalContentType] =
        React.useState<VariantsType>(null)
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const [disabled, setDisabled] = useState<boolean>(true)
    const [errorMessage1, setErrorMessage1] = useState<boolean>(false)
    const [errorMessage2, setErrorMessage2] = useState<boolean>(false)
    const [usedQR, setUsedQR] = useState<boolean>(false)
    const [invalidQR, setInvalidQR] = useState<boolean>(false)
    const [smallAmountQR, setSmallAmountQR] = useState<boolean>(false)

    const paymentEventParms = {
        pageName: 'QrPayment',
        pageURL: routes.payment,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    const navigateBack = () => {
        navigation(`/${routes.payment}`)
    }

    const handleQRInput = (value: string) => {
        if (value.length === 0) {
            setQrCode('')
            setDisabled(true)
        } else {
            setQrCode(value)
            setDisabled(false)
        }
    }
    const handlePayment = async () => {
        const idLocal = getLocalId()
        const token = currentUser && JSON.parse(currentUser).token
        const price = state.state.price
        const sLocal = getLocal()
        const establishment = user?.sEstablecimiento
        const idPayment = state.state.data.nId
        const paymentOrderData = {
            sQR: qrCode,
            sEstablecimiento: establishment,
            sLocal: sLocal,
            nMonto: price,
            codPromocion: '0',
        }
        loadingContext?.onOpen()
        try {
            await processPaymentOrderV2(
                idLocal,
                idPayment,
                paymentOrderData
            ).then(async (resp: any) => {
                loadingContext?.onClose()
                if (resp[1] === 200) {
                    navigation(`/${routes.successPayment}`, {
                        state: { data: resp[0] },
                    })
                    return
                }
                const codRespuesta = parseInt(resp[0].CodRespuesta)

                setModalContentType(null)
                setErrorMessage2(false)
                setUsedQR(false)
                setErrorMessage1(false)
                setSmallAmountQR(false)
                setInvalidQR(false)

                if (codRespuesta > 9 && codRespuesta < 18) {
                    track(
                        clevertapEvents.amiposweb_cobrafacil_pagoqr_no_realizado,
                        paymentEventParms
                    )
                    setErrorMessage2(true)
                    setModalContentType(VARIANTS.ERROR)
                } else if (codRespuesta === 52) {
                    track(
                        clevertapEvents.amiposweb_cobrafacil_pagoqr_invalido,
                        paymentEventParms
                    )
                    setInvalidQR(true)
                    setModalContentType(VARIANTS.ALERT)
                } else if (codRespuesta === 55) {
                    track(
                        clevertapEvents.amiposweb_cobrafacil_pagoqr_ya_usado,
                        paymentEventParms
                    )
                    setModalContentType(VARIANTS.ALERT)
                    setUsedQR(true)
                } else if (codRespuesta === 56) {
                    setSmallAmountQR(true)
                    setModalContentType(VARIANTS.ALERT)
                } else {
                    track(
                        clevertapEvents.amiposweb_cobrafacil_pagoqr_no_realizado,
                        paymentEventParms
                    )
                    setErrorMessage1(true)
                    setModalContentType(VARIANTS.ERROR)
                }
            })
        } catch (error) {
            loadingContext?.onClose()
            setErrorMessage1(true)
            setModalContentType(VARIANTS.ERROR)
            track(
                clevertapEvents.amiposweb_cobrafacil_pagoqr_no_realizado,
                paymentEventParms
            )
            track(
                clevertapEvents.amiposweb_cobrafacil_pagopos_error_tiempo,
                paymentEventParms
            )
        }
    }
    const handleCloseErrorModal = () => {
        setModalContentType(null)
    }
    return (
        <div className={styles.containertop}>
            <div className={styles.backIconContainer} onClick={navigateBack}>
                <img src={arrowBack} className={styles.arrowStyle} />
                <Text
                    label={labels.back}
                    variant="md-medium titleStyle"
                    fontSize={16}
                    fontWeight={500}
                />
            </div>
            <div className={styles.container}>
                <div className={styles.commonMargin}>
                    <div className={styles.qrCodeContainer}>
                        <Text
                            label={labels.paymentQRdigits}
                            variant="subtitle1 titleStyle"
                            fontSize={16}
                            fontWeight={600}
                            color={'#565656'}
                        />
                        <VerificationInput
                            length={8}
                            classNames={{
                                container: 'container',
                                character: styles.character,
                                characterInactive: 'character--inactive',
                                characterSelected: 'character--selected',
                            }}
                            placeholder="__"
                            onChange={handleQRInput}
                        />
                        <div
                            className={
                                qrCode.length < 8
                                    ? styles.buttonContainerDisabled
                                    : styles.buttonContainer
                            }
                            onClick={handlePayment}
                            aria-disabled={disabled ? true : false}
                        >
                            <Text
                                label={labels.paymentQRdigitsButton}
                                variant={`ButtonLg-16 ${styles.buttonTextStyle}`}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <ModalComponent
                show={!!modalContentType}
                handleClose={handleCloseErrorModal}
                modalStyle={styles.modalStyle}
            >
                {modalContentType === VARIANTS.ERROR && errorMessage1 && (
                    <ErrorModal
                        text={labels.paymentErrorMessage}
                        buttonText={labels.paymentContinue}
                        subtitle={labels.paymentRetry}
                        whatsappButton={false}
                        closeModal={handleCloseErrorModal}
                    />
                )}
                {modalContentType === VARIANTS.ERROR && errorMessage2 && (
                    <ErrorModal
                        text={labels.paymentErrorMessage}
                        buttonText={labels.paymentContinue}
                        subtitle={labels.paymentErrorMoreDetails}
                        whatsappButton={false}
                        closeModal={handleCloseErrorModal}
                    />
                )}
                {modalContentType === VARIANTS.ALERT && smallAmountQR && (
                    <AlertModal
                        text={labels.paymentErrorMessage}
                        buttonText={labels.retry}
                        subtitle={labels.paymentErrorSmallAmount}
                        closeModal={handleCloseErrorModal}
                    />
                )}
                {modalContentType === VARIANTS.ALERT && invalidQR && (
                    <AlertModal
                        text={labels.qrPaymentErrorMessage}
                        buttonText={labels.continue}
                        subtitle={labels.paymentErrorNewQR}
                        closeModal={handleCloseErrorModal}
                    />
                )}
                {modalContentType === VARIANTS.ALERT && usedQR && (
                    <AlertModal
                        text={labels.paymentErrorQRUsed}
                        buttonText={labels.continue}
                        subtitle={labels.paymentErrorNewQR2}
                        closeModal={handleCloseErrorModal}
                    />
                )}
            </ModalComponent>
        </div>
    )
}
